import { AttachmentConstants } from 'owa-attachment-model-store/lib/utils/attachmentConstants';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemAttachment from 'owa-service/lib/contract/ItemAttachment';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import {
    AttachmentFile,
    AttachmentItemFile,
    AttachmentFileType,
    CloudFile,
} from 'owa-attachment-file-types';

/**
 * This creates an AttachmentFile from an attachment that already exists in a users mailbox
 * Reference Attachments that already exist in the users mailbox are represented as cloudy files with a Mailbox provider
 * Non-Reference attachments that exist in the users mailbox are represented as attachmentItem files
 * @param attachment an attachment that exists in the users mailbox
 */
export default function createAttachmentFileFromExistingMailboxAttachment(
    attachment: AttachmentType
): AttachmentFile {
    if (attachment.__type === AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE) {
        const refAttachment = attachment as ReferenceAttachment;
        const cloudFile: CloudFile = {
            fileType: AttachmentFileType.Cloud,
            name: refAttachment.Name,
            size: refAttachment.Size,
            providerId: '',
            providerType: AttachmentDataProviderType.Mailbox,
            location: refAttachment.AttachLongPathName,
            providerEndpointUrl: '',
            isFolder: false,
            thumbnailUrl: refAttachment.AttachmentThumbnailUrl,
            previewUrl: refAttachment.AttachmentPreviewUrl,
            fileId: refAttachment.AttachmentId.Id,
            fileParentId: '',
            type: refAttachment.ContentType,
        };
        return cloudFile;
    } else {
        const attachmentItemFile: AttachmentItemFile = {
            attachmentItemId: attachment.AttachmentId.Id,
            name: attachment.Name,
            size: attachment.Size,
            fileType: AttachmentFileType.AttachmentItem,
            type: AttachmentConstants.attachmentTypes.ITEM_ID_ATTACHMENT_TYPE,
            EmbeddedItemClass: (<ItemAttachment>attachment).EmbeddedItemClass,
            ContentType: attachment.ContentType,
        };
        return attachmentItemFile;
    }
}
